import * as React from 'react';
import axios from 'axios';
import { createRoot } from 'react-dom/client';
import { Main } from './Main';

interface IConfig {
  apiURL:         string;
  mapboxKey:      string;
  keycloakURL:    string;
  keycloakRealm:  string;
  keycloakClient: string;
}

class App {
  static config: IConfig;
  // Current Keycloak access token, kept up to date by <Auth>. Read by the axios
  // request interceptor below to authenticate every API call via a Bearer header.
  static accessToken: string | null = null;
  // Called by the axios response interceptor on a 401 (set by <Auth> to log out).
  static onUnauthorized: (() => void) | null = null;

  static run = (node: React.ReactNode) => {
    const root = createRoot(document.getElementById('root'));
    axios.get<IConfig>("config.json")
    .then((res) => {
      App.config = res.data;
      if(!App.config.apiURL.endsWith('/')) App.config.apiURL += '/';

      // Attach the Keycloak bearer token to every request.
      axios.interceptors.request.use((config) => {
        if (App.accessToken) {
          config.headers.set('Authorization', `Bearer ${App.accessToken}`);
        }
        return config;
      });
      // A 401 means the token is gone/expired — hand off to Keycloak to re-auth.
      axios.interceptors.response.use(undefined, (error) => {
        if (error?.response?.status === 401 && App.onUnauthorized) {
          App.onUnauthorized();
        }
        return Promise.reject(error);
      });

      root.render(node);
    })
    .catch(() => {
      // Remove loading screen.
      document.getElementById("apploader").remove();
      root.render(
        "Error: Could not load config.json."
      );
    });
  }
}

App.run(<Main/>);

export { App }
